module.exports = __webpack_public_path__ + "img/k02.6f7e197c.png";